import React, { Component } from 'react';

import { fetchCycles } from 'api';

const withCycles = (DecoratedComponent) => {
  class WithCycles extends Component {
    constructor(props) {
      super(props);

      this.state = {
        cycles: undefined,
      };
    }

    componentDidMount() {
      this.fetchCycles();
    }

    async fetchCycles() {
      const { data } = await fetchCycles();
      this.setState({
        cycles: data,
      });
    }

    render() {
      const { children, ...props } = this.props;
      const { cycles } = this.state;

      return React.createElement(
        DecoratedComponent,
        { ...props, cycles },
        children,
      );
    }
  }

  return WithCycles;
};

export default withCycles;
